<template>
	<div>
		<MobileOrderSummary/>

		<BContainer>
			<ShippingBanner/>
			<BlacklistBanner/>
			<ProductLimitBanner/>

			<KeepAlive>
				<CountdownTimer
					v-if="countdownDuration"
					:duration="countdownDuration"
				/>
			</KeepAlive>

			<FormSections/>

			<Carousel
				v-if="carouselItems.length"
				:items="carouselItems"
				:description="carouselDescription"
			/>

			<Reviews v-if="reviewItems.length" :reviews="reviewItems"/>
		</BContainer>
	</div>
</template>

<script>
import {
	CountdownTimer,
	Carousel,
	Reviews,
} from '@component/user-backend/Checkout/V4/addons';
import BlacklistBanner from '@component/user-backend/Checkout/V4/sections/banners/BlacklistBanner.vue';
import ShippingBanner from '@component/user-backend/Checkout/V4/sections/banners/ShippingBanner.vue';
import FormSections from './sections/FormSections.vue';
import MobileOrderSummary from './MobileOrderSummary.vue';
import ProductLimitBanner from './sections/banners/ProductLimitBanner.vue';

export default {
	components: {
		ProductLimitBanner,
		CountdownTimer,
		Carousel,
		Reviews,
		FormSections,
		MobileOrderSummary,
		BlacklistBanner,
		ShippingBanner,
	},

	props: {
		countdownDuration: {
			type: Number,
			default: 0,
		},
		carouselItems: {
			type: Array,
			default: () => [],
		},
		carouselDescription: {
			type: String,
			default: '',
		},
		reviewItems: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
